import {Component, Input} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {TmwTranslateDirective} from '@shared/directives/translate.directive';

@Component({
  selector: 'tmw-validation-message',
  standalone: true,
  imports: [TmwTranslateDirective],
  templateUrl: './validation-message.component.html',
  styleUrl: './validation-message.component.scss',
})
export class TmwValidationMessageComponent {
  @Input({required: true}) control!: NgModel;
  form: NgForm | undefined;
  @Input() module!: string;

  ngOnInit() {
    this.form = this.control.formDirective as NgForm;
  }
}
